<wilson-filter-label [label]="label">
  <nz-input-wrapper>
    <ng-container nzInputSuffix [ngTemplateOutlet]="suffixIconSearch" />
    <input
      nz-input
      type="text"
      [placeholder]="placeholder || 'account.search' | translate"
      [ngModel]="value"
      (ngModelChange)="searchTermSubject.next($event)"
      (focus)="isFocusing.emit(true)"
      (blur)="isFocusing.emit(false)"
      data-test-id="wilson-basic-search-filter:input"
    />
  </nz-input-wrapper>
  <ng-template #suffixIconSearch>
    @if (value) {
      @if (value) {
        <span
          nz-icon
          nzTheme="outline"
          nzType="close-circle"
          class="xmark-icon"
          (click)="inputChanged.emit('')"
        ></span>
      }
    } @else {
      <fa-icon
        [icon]="faSearch"
        class="d-flex align-items-center justify-content-center"
      ></fa-icon>
    }
  </ng-template>
</wilson-filter-label>
